import { useNavigate } from 'react-router-dom';
import { Gamepad2, Pickaxe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ArcheEngineLanding } from '../../../components/ArcheEngineLanding';

const ARCHE_ID = 'arche_dfe_mining';
/** Bare LitCraft game arche (plugin); opened as a best-effort link. */
const LITCRAFT_PATH = '/a/litcraft';
/** Lit Mining game arche (plugin); opened as a best-effort link. */
const LIT_MINING_PATH = '/a/lit-mining';

/**
 * Landing screen for the DFE Mining arche.
 *
 * This arche is the mining engine behind the LitCraft universe — the lands,
 * blocks, and mined items that games and plugins read and write through the
 * mining Entity. It is not a user-facing app, so end users see a friendly
 * "nothing to see here" screen with links out to the games that use it.
 *
 * The live data path (external game via `routes/ext/mining`, the Lit Mining
 * plugin via the mining Entity, and DFE Crafting's tool-upgrade calls into
 * `mining-service`) is entirely separate from this UI.
 */
export function MiningLandingPage() {
  const navigate = useNavigate();

  return (
    <ArcheEngineLanding
      archeId={ARCHE_ID}
      title="Mining"
      description={
        <>
          This is the mining engine behind the games you love in the LitCraft universe — the lands,
          blocks, and treasures that power your adventures. There's nothing for you to do on this
          page.
        </>
      }
      actions={
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button onClick={() => navigate(LITCRAFT_PATH)} className="gap-2">
            <Gamepad2 className="h-4 w-4" />
            Open LitCraft
          </Button>
          <Button onClick={() => navigate(LIT_MINING_PATH)} variant="outline" className="gap-2">
            <Pickaxe className="h-4 w-4" />
            Open Lit Mining
          </Button>
        </div>
      }
    />
  );
}
